$(function () {
  $('#modal').on('show.bs.modal', function (e) {
    const button = $(e.relatedTarget);
    const title = button.data('title') ? button.data('title') : '';
    const content = JSON.parse(button.data('content'));
    const video = button.data('video') ? button.data('video') : '';
    const offcanvas = button.data('offcanvas') ? button.data('offcanvas') : '';
    const modal = $(this);

    if (video) {
      modal.addClass('modal-video');
      $('body').addClass('modal-open-video');
    } else if (offcanvas) {
      modal.addClass('modal-offcanvas');
    }

    const modalLabel = modal.find('#modalLabel');
    if (title && modalLabel.length) {
      modalLabel.text(title);
    }
    modal.find('.modal-body').html(content);
  });

  $('#modal').on('hidden.bs.modal', function () {
    const modal = $(this);
    $('body').removeClass('modal-open-video');
    modal.removeClass('modal-video');
    modal.removeClass('modal-offcanvas');
    modal.find('.modal-body').html('');
  });

  // Gravity forms on submit
  $(document).on('gform_confirmation_loaded', function (e, formID) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'formSubmission',
      formID: formID,
      formName:
        !!window.suiteSevenGravityFormTitle &&
        !!window.suiteSevenGravityFormTitle[formID]
          ? window.suiteSevenGravityFormTitle[formID]
          : `Undefined - ${formID}`,
    });
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-product-gallery-thumb]');

    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      const mainImage = gallery?.querySelector('[data-product-gallery-main]');

      if (!mainImage || !thumb.dataset.imageSrc) {
        return;
      }

      mainImage.src = thumb.dataset.imageSrc;
      mainImage.alt = thumb.dataset.imageAlt || '';

      ['srcset', 'sizes'].forEach((attribute) => {
        const value =
          thumb.dataset[
            `image${attribute[0].toUpperCase()}${attribute.slice(1)}`
          ];
        value
          ? mainImage.setAttribute(attribute, value)
          : mainImage.removeAttribute(attribute);
      });

      gallery
        .querySelectorAll('[data-product-gallery-thumb]')
        .forEach((galleryThumb) =>
          galleryThumb.setAttribute('aria-current', galleryThumb === thumb),
        );
      return;
    }

    const button = event.target.closest('[data-quantity-action]');

    if (!button) {
      return;
    }

    const input = button.closest('[data-quantity]')?.querySelector('input.qty');

    if (!input || input.disabled || input.readOnly) {
      return;
    }

    const step = Number(input.step) || 1;
    const min = input.min !== '' ? Number(input.min) : 1;
    const max = input.max !== '' ? Number(input.max) : Infinity;
    const current = Number(input.value) || min;
    const nextValue =
      button.dataset.quantityAction === 'increase'
        ? Math.min(current + step, max)
        : Math.max(current - step, min);

    input.value = nextValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-news-slider]').forEach((newsSlider) => {
    const slider = newsSlider.querySelector('[data-news-items]');
    const thumb = newsSlider.querySelector('[data-news-progress-thumb]');

    if (!slider || !thumb) {
      return;
    }

    const itemCount = slider.children.length;
    thumb.style.width = `${100 / itemCount}%`;

    slider.addEventListener(
      'scroll',
      () => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const scrollProgress =
          maxScroll > 0 ? slider.scrollLeft / maxScroll : 0;

        thumb.style.transform = `translateX(${scrollProgress * (itemCount - 1) * 100}%)`;
      },
      { passive: true },
    );
  });
});
